import React from 'react';
import { connect } from 'react-redux';
import { onCodeScroll } from '@/hooks/paging';
import CohortCards from '@/cohorts/components/CohortCards';
import RequestCohortsContainer, {
  mapStateToProps,
  mapDispatchToProps,
} from '../components/RequestCohortsContainer';
import RequestCohortsFilters from './RequestCohortsFilters';

const RequestCohortCards = ({
  canCreate,
  category,
  code,
  currentPage,
  cohorts,
  fetchData,
  newCohortCode,
  onCheckBoxClick,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
}) => (
  <RequestCohortsContainer category={category} code={code} readStatus={readStatus} fetchData={fetchData}>
    <div className="sticky-panel-header">
      <RequestCohortsFilters category={category} code={code} className="aridhia-list-filter" fluid />
    </div>
    <CohortCards
      canCreate={canCreate}
      category={category}
      handleScroll={() => onCodeScroll(fetchData, category, code, currentPage, pageCount, pageSize)}
      items={cohorts}
      itemsPerRow={1}
      newCohortCode={newCohortCode}
      onCheckBoxClick={(value) => onCheckBoxClick(category, code, value)}
      readErrors={readErrors}
      readStatus={readStatus}
      single
    />
  </RequestCohortsContainer>
);

export default connect(mapStateToProps, mapDispatchToProps)(RequestCohortCards);
